import React, { useState } from 'react';
import styles from './submissionForm.css';

const FORM_STATE = {
  IDLE: 'idle',
  SUCCESS: 'success',
  ERROR: 'error',
  SUBMITTING: 'submitting',
};

const SubmissionForm = () => {
  const [formState, setFormState] = useState(FORM_STATE.IDLE);

  const handleSubmit = async e => {
    e.preventDefault();
    setFormState(FORM_STATE.SUBMITTING);

    const formElements = [...e.currentTarget.elements];
    const urlEncodedForm = formElements
      .filter(el => !!el.value)
      .map(el => `${encodeURIComponent(el.name)}=${encodeURIComponent(el.value)}`)
      .join('&');

    await fetch('/', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: urlEncodedForm,
    })
      .then(() => {
        setFormState(FORM_STATE.SUCCESS);
      })
      .catch(e => {
        setFormState(FORM_STATE.ERROR);
        console.error(e);
      });
  };

  let submittedText;
  if (formState === FORM_STATE.SUCCESS) {
    submittedText = 'Thank you!';
  } else if (formState === FORM_STATE.ERROR) {
    submittedText = 'Oops! Something went wrong...';
  }

  return (
    <div className={styles.formWrapper}>
      <span className={styles.formDivider}>✺✺✺✺✺</span>
      <h2 className={styles.formTitle}>Ask us anything!</h2>
      <p className={styles.formDescription}>
        While we’re happy to weigh in on literally anything (fashion, what car to buy, the best character on Friday Night Lights, etc.) our specialty lies in the art direction realm. Ask us your darkest questions about needy clients, budgets, and how to stay inspired in our chaotic times.
      </p>
      {formState === FORM_STATE.IDLE ? (
        <form
          className={styles.form}
          name="question-submission"
          method="post"
          onSubmit={handleSubmit}>
          <input type="hidden" name="form-name" value="question-submission" />
          <p className={styles.formField}>
            <label className={styles.formLabel} htmlFor="name">
              Name
            </label>
            <input className={styles.formInput} type="text" id="name" name="name" />
          </p>
          <p className={styles.formField}>
            <label className={styles.formLabel} htmlFor="email">
              Email
            </label>
            <input className={styles.formInput} type="email" id="email" name="email" />
          </p>
          <p className={styles.formField}>
            <label className={styles.formLabel} htmlFor="question">
              Your Q <span style={{ color: 'red' }}>*</span>
            </label>
            <textarea className={styles.formTextInput} id="question" name="question" required />
          </p>
          <p>
            <button className={styles.formButton} type="submit">
              Submit
            </button>
          </p>
        </form>
      ) : (
        <div>
          <p className={styles.formText}>{submittedText}</p>
          <button className={styles.formButton} onClick={() => setFormState(FORM_STATE.IDLE)}>
            Ask again
          </button>
        </div>
      )}
    </div>
  );
};

SubmissionForm.propTypes = {};

export default SubmissionForm;
